import { userService } from './../../../Services/userService';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TPLProposal } from '../../../Models/TPLProposal';
import { RenewBindMdl } from '../../../Models/RenewBindMdl';
import { restURL } from '../../../Models/restURL';
import { renewalProposalService } from '../../../Services/renewalProposalService';
import { DriverDetails } from '../../../Models/TPLProposal';
import { DriverLicenceReq, DriverLicenceRes } from '../../../Models/DriverLicenceReq';
import { LanguageService } from '../../../Services/languageService';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import { mdlDriverInfoReq } from '../../../Models/mdlDriverInfoReq';
import { mdlDriverInfoRes } from '../../../Models/mdlDriverInfoRes';
import Swal from 'sweetalert2';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { motorProposalService } from '../../../Services/motorProposalService';


@Component({
  selector: 'RenewalDriverInfo',
  templateUrl: './RenewalDriverInfo.html',
  styleUrls: ['./RenewalDriverInfo.css']
})
export class RenewalDriverInfo implements OnDestroy {

  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public prObj: TPLProposal = new TPLProposal();
  public bindObj: RenewBindMdl = new RenewBindMdl();
  public subscription: Subscription;
  public bindSubscription: Subscription;
  public diverObj: DriverDetails = new DriverDetails();
  public DriverId: string;
  public DriverMM: string;
  public DriverDD: string;
  public DriverYY: string;
  public isShowLoading: boolean;
  public isError: boolean;
  public ErrorMsg: string;
  public NoLicenseExpDate: boolean;
  public ErrorYear: boolean = false;
  public isGregorian: boolean = false;
  public DriverLic_ExpiryDate_Long: Date;
  public DriverLicExpYY: string;
  public DriverLicExpMM: string;
  public DriverLicExpDD: string;

  public driverLicReq: DriverLicenceReq = new DriverLicenceReq();
  public driverLicRes: DriverLicenceRes = new DriverLicenceRes();
  public objmdlDriverInfoReq: mdlDriverInfoReq = new mdlDriverInfoReq();
  public objmdlDriverInfoRes: mdlDriverInfoRes = new mdlDriverInfoRes();
  public LngSubscription: Subscription;
  public Lng: string;
  public isSearchSubmitted: boolean = false;
  public isDriverSubmitted: boolean = false;
  public Mindate: Date = new Date;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  @ViewChild('closeBtn') closeBtn: ElementRef;
  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private proposalService: renewalProposalService, private trackingObj: MotorproposalTrackingService, private userinfo: userService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.prObj = this.proposalService.getRenewalProposalObj();
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }

    this.bindObj = this.proposalService.getRenewalBindObj();
    this.NoLicenseExpDate = false;
    this.driverLicRes.st.StatusCode = "F";
    this.diverObj.DriverCity = "0";
    this.diverObj.DriverEducation = "5";
    this.diverObj.DriverProfession = "1";
    this.diverObj.OtherCountriesLicenceHeld = "0";
    this.diverObj.DriverMedicalConditions = "0";
    this.diverObj.DriverMaritalStatus = "0";
    this.diverObj.DriverNationality = "0";
    this.diverObj.isMainDriver = "1";
    this.diverObj.gender = "0";
    this.diverObj.SaudiLicenceHeld = "0";
    this.diverObj.RelationWithInsured = "0";
    this.diverObj.RoadConvictions = 74;
    this.diverObj.DriverChildrenYears = "1";
    this.diverObj.SaudiLicenceHeld = "0";
    this.diverObj.OtherCountriesLicenceHeld = "341";
    this.diverObj.NumberOfYearsEachCountry = "1";
    this.diverObj.DriverMedicalConditions = "7";
    this.diverObj.OfficeCity = 0;
    this.diverObj.DriverChildrenYears = "1";


  }
  ngOnDestroy() {

  }

  CheckYear(value) {
    var CurrentYear = new Date().getFullYear();
    if (value < CurrentYear) {
      this.ErrorYear = true;
      this.NoLicenseExpDate = false;
    } else {
      this.ErrorYear = false;

    }
  }


  DriverSearch(valid) {
    this.isSearchSubmitted = true;

    let DriverCount: number = 0;
    DriverCount = this.prObj.Drivers.length;

    let DriverLimit: number = 3;
    DriverLimit = this.prObj.DriverMaxLimit;
    if (DriverCount >= DriverLimit) {
      this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين ") : Swal("You can't add more than " + DriverLimit + " drivers")
      return;
    }


    let DriverLicCount: number = 0;
    this.isError = false;
    this.ErrorMsg = "";

    DriverLicCount = this.prObj.Drivers.filter(t => t.DriverLicenseNo == this.DriverId).length;

    if (DriverLicCount > 0) {
      this.Lng == "ar" ? Swal("بيانات السائق موجودة مسبقا") : Swal("Driver Licence No Already Existed");
      return;
    }


    if (valid) {
      this.isShowLoading = true;
      this.objmdlDriverInfoReq.DriverId = this.DriverId;
      if (this.DriverId.startsWith("1")) {
        this.objmdlDriverInfoReq.IdExpiry = this.DriverMM + "-" + this.DriverYY;
        this.objmdlDriverInfoReq.DOB = '';
      }
      else {
        this.objmdlDriverInfoReq.DOB = this.DriverMM + "-" + this.DriverYY;
        this.objmdlDriverInfoReq.IdExpiry = "";
      }

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlDriverInfoReq));

      //this.http.post<mdlDriverInfoRes>(this.url.baseURL + "/DriverInfo/GetDriverInfo_New", this.objmdlDriverInfoReq, this.userinfo.getHttpOptions())
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/DriverInfo/GetDriverInfo_New", this.objPayloadRequest, this.userinfo.getHttpOptions())
        .toPromise().then((result) => {
          // this.objmdlDriverInfoRes = result;

          //New Line Start
          this.objPayloadResponse = result;
          this.objmdlDriverInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
          //NewLine End


          this.isShowLoading = false;
          if (this.objmdlDriverInfoRes.Status.StatusCode == "F") {
            Swal(this.objmdlDriverInfoRes.Status.StatusDecEn);
          }
          else {
            this.diverObj.DriverNameAr = this.objmdlDriverInfoRes.ArabicFullName;
            this.diverObj.DriverNameEn = this.objmdlDriverInfoRes.EnglishFullName;
            this.diverObj.DriverLicIssueDate = '';
            this.diverObj.DriverLicenseNo = this.objmdlDriverInfoReq.DriverId;
            this.diverObj.DriverDOB = this.objmdlDriverInfoRes.DateOfBirth;
            this.diverObj.Driver_Age = this.objmdlDriverInfoRes.DriverAge;
            this.diverObj.DriverCity = this.objmdlDriverInfoRes.IDCityCode;

            this.diverObj.DriverNationality = this.objmdlDriverInfoRes.NationalityCode;
            if (this.diverObj.DriverCity != null) {
              this.ResCityChange(this.diverObj.DriverCity);
            }
            else {
              this.diverObj.DriverCity = "0";
            }
            if (this.objmdlDriverInfoRes.Gender != null) {
              this.diverObj.Drivergender = this.objmdlDriverInfoRes.Gender == "M" ? "1" : "2";
            }
          }
          if (Number(this.diverObj.Driver_Age) < 17 || Number(this.diverObj.Driver_Age) > 100) {
            //this.isError = true;
            this.Lng == "ar" ? Swal("يجب أن يكون عمر السائق بين 17 و 100 عام") : Swal("Driver Age must be between 17 and 100 only");
            this.diverObj.DriverNationality = '';
            this.diverObj.DriverLicenseNo = '';
            this.DriverId = '';
            this.DriverMM = '';
            this.DriverYY = ''
            this.diverObj.DriverCity = '';
            this.diverObj.DriverNameAr = "";
            this.diverObj.DriverNameEn = "";
            this.closeBtn.nativeElement.click();
          }
          else {
            this.isError = false;
            this.ErrorMsg = "";
            if (Number(this.diverObj.Driver_Age) < 25) {
              this.diverObj.DriverLicenseType = "8";
            }
            else {
              this.diverObj.DriverLicenseType = "9";
            }

          }


        },
          (error) => {
            this.isShowLoading = false;
            this.userinfo.checkTokenStatus(error);
          });
    }
  }


  public CalculateAge(DD, MM, YYYY): number {
    var dage: number;
    var todayDate = new Date(),
      todayYear = todayDate.getFullYear(),
      todayMonth = todayDate.getMonth(),
      todayDay = todayDate.getDate(),
      dage = todayYear - YYYY;

    if (todayMonth < MM.date - 1) {
      dage--;
    }

    if (MM.date - 1 === todayMonth && todayDay < DD.date) {
      dage--;
    }
    return dage;
  }

  SetDOBType(ID) {

    var IDType: string;
    IDType = ID;
    if (IDType != "") {
      if (IDType.charAt(0) == "1") {
        this.isGregorian = false;
      }
      else {
        this.isGregorian = true;
      }
    }

  }


  AddNewDriver(valid) {
    this.isDriverSubmitted = true;
    if (this.ErrorYear) {
      return;
    }
    if (valid) {
      let newDriverObj: DriverDetails = new DriverDetails();
      let DriverLicCount: number = 0;
      let DriverCount: number = 0;
      let mainDriverCount: number = 0;

      let DriverLimit: number = 3;
      DriverLimit = this.prObj.DriverMaxLimit;
      //this.diverObj.DriverLic_ExpiryDate = this.DriverLicExpDD+"-"+this.DriverLicExpMM+"-"+ this.DriverLicExpYY;
      // this.diverObj.DriverLic_ExpiryDate = this.diverObj.DriverLicYY+"-"+this.diverObj.DriverLicMM+"-"+this.diverObj.DriverLicDD;

      DriverCount = this.prObj.Drivers.length;
      if (DriverCount > DriverLimit) {
        this.Lng == "ar" ? Swal("لا يمكنك إضافة أكثر من ثلاثة سائقين") : Swal("You can't add more than " + DriverLimit + " drivers");

      }
      else {
        DriverLicCount = this.prObj.Drivers.filter(t => t.DriverLicenseNo == this.diverObj.DriverLicenseNo).length;
        if (DriverLicCount == 0) {
          if (this.diverObj.isMainDriver == "1") {
            mainDriverCount = this.prObj.Drivers.filter(t => t.isMainDriver == "1").length;
          }
          if (mainDriverCount > 0) {
            this.Lng == "ar" ? Swal("يسمح بإضافة سائق رئيسي واحد فقط") : Swal("Only one main Driver is allowed to add");

          }
          else {
            newDriverObj.isMainDriver = this.diverObj.isMainDriver;
            newDriverObj.DriverLicenseNo = this.diverObj.DriverLicenseNo;
            newDriverObj.DriverDOB = this.diverObj.DriverDOB;
            if (this.diverObj.isMainDriver == "1") {
              newDriverObj.isMainDriverEn = "Yes";
              newDriverObj.isMainDriverEn = "Yes";
            }
            else if (this.diverObj.isMainDriver == "2") {
              newDriverObj.isMainDriverEn = "No";
              newDriverObj.isMainDriverEn = "No";
            }
            newDriverObj.DriverNameAr = this.diverObj.DriverNameAr;
            newDriverObj.DriverNameEn = this.diverObj.DriverNameEn;
            newDriverObj.DriverLicIssueDate = this.diverObj.DriverLicIssueDate;

            newDriverObj.DriverNationalityEn = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescEn;
            newDriverObj.DriverNationalityAr = this.bindObj.NationalityMasterList.filter(t => t.NationalityDesc == this.diverObj.DriverNationality)[0].NationalityDescAr;
            newDriverObj.DriverNationality = this.diverObj.DriverNationality;

            newDriverObj.DriverLicenseTypeEn = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescEn;
            newDriverObj.DriverLicenseTypeAr = this.bindObj.LicenceTypeList.filter(t => t.LicTypecode == Number(this.diverObj.DriverLicenseType))[0].LicType_DescAr;
            newDriverObj.DriverLicenseType = this.diverObj.DriverLicenseType;

            newDriverObj.DriverMaritalStatusEn = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_En;
            newDriverObj.DriverMaritalStatusAr = this.bindObj.MarStatusList.filter(t => t.MarstatusCode == this.diverObj.DriverMaritalStatus)[0].MarstatusDesc_Ar;
            newDriverObj.DriverMaritalStatus = this.diverObj.DriverMaritalStatus;

            newDriverObj.DriverCity = this.diverObj.DriverCity;
            newDriverObj.DriverEducation = this.diverObj.DriverEducation;
            newDriverObj.SaudiLicenceHeld = this.diverObj.SaudiLicenceHeld;
            newDriverObj.DriverProfession = this.diverObj.DriverProfession;
            newDriverObj.DriverChildrenYears = this.diverObj.DriverChildrenYears;
            newDriverObj.OtherCountriesLicenceHeld = this.diverObj.OtherCountriesLicenceHeld;
            newDriverObj.NumberOfYearsEachCountry = this.diverObj.NumberOfYearsEachCountry;
            newDriverObj.DriverMedicalConditions = this.diverObj.DriverMedicalConditions;
            newDriverObj.DriverAddress = this.diverObj.DriverAddress;
            newDriverObj.gender = this.diverObj.Drivergender;
            newDriverObj.Driver_Age = this.diverObj.Driver_Age;
            newDriverObj.RelationWithInsured = this.diverObj.RelationWithInsured;
            newDriverObj.DriverLicIssueDate = this.diverObj.DriverLic_ExpiryDate;

            newDriverObj.ResidenceAdditionalNumber = this.diverObj.ResidenceAdditionalNumber;
            newDriverObj.ResidenceBuildingNumber = this.diverObj.ResidenceBuildingNumber;
            newDriverObj.ResidenceCity = Number(this.diverObj.DriverCity);
            newDriverObj.ResidenceDistrict = this.diverObj.ResidenceDistrict;
            newDriverObj.ResidenceStreet = this.diverObj.ResidenceStreet;
            newDriverObj.ResidenceUnitNumber = this.diverObj.ResidenceUnitNumber;
            newDriverObj.ResidenceZipCode = this.diverObj.ResidenceZipCode;
            newDriverObj.ResidenceZone = this.diverObj.ResidenceZone;

            newDriverObj.OfficeUnitNumber = this.diverObj.OfficeUnitNumber;
            newDriverObj.OfficeZone = this.diverObj.OfficeZone;
            newDriverObj.OfficeZipCode = this.diverObj.OfficeZipCode;
            newDriverObj.OfficeAdditionalNumber = this.diverObj.OfficeAdditionalNumber;
            newDriverObj.OfficeBuildingNumber = this.diverObj.OfficeBuildingNumber;
            newDriverObj.OfficeDistrict = this.diverObj.OfficeDistrict;
            newDriverObj.OfficeStreet = this.diverObj.OfficeStreet;
            newDriverObj.OfficeCity = this.diverObj.OfficeCity;

            newDriverObj.RoadConvictions = this.diverObj.RoadConvictions;


            if (this.diverObj.DriverLicenseNo) {
              if (this.diverObj.DriverLicenseNo.startsWith("1")) {
                newDriverObj.DriverIDType = "1";
              }
              else {
                newDriverObj.DriverIDType = "2";
              }
            }

            if (this.Lng == "en") {
              newDriverObj.LangFlag = "E";
            }
            else {
              newDriverObj.LangFlag = "A";
            }


            this.prObj.Drivers.push(newDriverObj);
            this.Lng == "ar" ? Swal("تمت إضافة بيانات السائق بنجاح") : Swal("Driver added successfully");

            this.diverObj.isMainDriver = "1";
            this.diverObj.DriverLicenseNo = "";
            this.diverObj.DriverDOB = "";
            this.diverObj.DriverNameAr = "";
            this.diverObj.DriverNameEn = "";
            this.diverObj.DriverLicIssueDate = "";

            this.diverObj.DriverAddress = "";
            this.diverObj.gender = "0";
            this.DriverLic_ExpiryDate_Long = null;
            this.diverObj.DriverMaritalStatus = '';
            this.diverObj.RelationWithInsured = "0";
            this.diverObj.DriverNationality = "0";
            this.diverObj.DriverLicenseType = "0";
            this.DriverId = "";
            this.DriverDD = "";
            this.DriverMM = "";
            this.DriverYY = "";
            this.DriverLicExpDD = "";
            this.DriverLicExpMM = "";
            this.DriverLicExpYY = "";
            this.DriverLic_ExpiryDate_Long = null;
            this.diverObj.DriverMaritalStatus = '0';

            this.diverObj.ResidenceAdditionalNumber = null;
            this.diverObj.ResidenceBuildingNumber = null;
            this.diverObj.DriverCity = "0";
            this.diverObj.ResidenceDistrict = "";
            this.diverObj.ResidenceStreet = "";
            this.diverObj.ResidenceUnitNumber = null;
            this.diverObj.ResidenceZipCode = null;
            this.diverObj.ResidenceZone = "";


            this.diverObj.OfficeAdditionalNumber = null;
            this.diverObj.OfficeBuildingNumber = null;
            this.diverObj.OfficeCity = 0
            this.diverObj.OfficeDistrict = "";
            this.diverObj.OfficeStreet = "";
            this.diverObj.OfficeUnitNumber = null;
            this.diverObj.OfficeZipCode = null;
            this.diverObj.OfficeZone = "";


            this.diverObj.DriverEducation = "5";
            this.diverObj.SaudiLicenceHeld = "0";
            this.diverObj.DriverProfession = "1";
            this.diverObj.DriverChildrenYears = "1";
            this.diverObj.OtherCountriesLicenceHeld = "341";
            this.diverObj.NumberOfYearsEachCountry = "1";
            this.diverObj.DriverMedicalConditions = "7";
            this.diverObj.RoadConvictions = 74;

            this.diverObj.DriverLic_ExpiryDate = "";

            this.closeBtn.nativeElement.click();

          }
        }
        else {
          this.Lng == "ar" ? Swal("بيانات السائق موجودة مسبقا") : Swal("Driver Licence No Already Existed");
        }
      }
    }
  }


  removeDriver(index) {
    this.prObj.Drivers.splice(index, 1);
  }


  goPrev() {
    this.proposalService.saveRenewalProposalObj(this.prObj);
    this.proposalService.sendRenewBindInfo(this.bindObj);
    sessionStorage.setItem("CurrentRoute", "RenewalBasicInfo");

    if (this.prObj.Drivers.length <= 0) {
      sessionStorage.setItem("NoDriver", "Y");
    }

    if (this.prObj.st.StatusCode != "F") {
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalBasicInfo']);
    }

  }

  countMainDrivers(): number {
    let mainDriverCount: number = 0;

    mainDriverCount = this.prObj.Drivers.filter(t => t.isMainDriver == "1").length;

    return mainDriverCount;
  }

  GoNext() {
    let DriverLimit: number = 3;
    DriverLimit = this.prObj.DriverMaxLimit;

    if (this.prObj.Drivers.length > 0) {

      if (this.prObj.Drivers.length > DriverLimit) {
        this.Lng == "ar" ? this.ErrorMsg = "للا يمكنك إضافة أكثر من ثلاثة سائقين" : this.ErrorMsg = "You can not add more than " + DriverLimit + " drivers";
        this.isError = true;
        return;
      }


      if (this.countMainDrivers() > 0) {

        if (this.prObj.isInsured && this.prObj.Drivers.length == 1) {
          this.Lng == "ar" ? this.ErrorMsg = "يرجى إضافة واحد على الأقل سائق واحد غير السائق الرئيسي للمضي قدما" : this.ErrorMsg = "Please Add atleast one driver other than main driver to proceed further";
          this.isError = true;
          return;
        }

        if (this.prObj.isInsured && this.prObj.Drivers.length == 1) {
          this.Lng == "ar" ? this.ErrorMsg = "يرجى إضافة واحد على الأقل سائق واحد غير السائق الرئيسي للمضي قدما" : this.ErrorMsg = "Please Add atleast one driver other than main driver to proceed further";
          this.isError = true;
          return;
        }



        this.ErrorMsg = "";
        this.isError = false;









        sessionStorage.setItem("CurrentRoute", "RenewalPremiumInfo");
        this.proposalService.saveRenewalProposalObj(this.prObj);
        this.proposalService.saveRenewalBindObj(this.bindObj);
        if (this.prObj.st.StatusCode != "F") {
          this.router.navigate(['NewDashboard/RenewalProposal/RenewalPremiumInfo']);
        }


      }
      else {
        this.Lng == "ar" ? this.ErrorMsg = "الرجاء إضافة  سائق رئيسي واحد على الأقل للمتابعة" : this.ErrorMsg = "Please Add atleast one  main driver to proceed further";
        this.isError = true;
      }


    }
    else {
      this.Lng == "ar" ? this.ErrorMsg = "الرجاء إضافة  سائق رئيسي واحد على الأقل للمتابعة" : this.ErrorMsg = "Please Add atleast one  main driver to proceed further";
      this.isError = true;
    }
  }


  CheckLicenseExpiry() {
    let CurrentDate: Date;
    CurrentDate = new Date();
    if (this.DriverLic_ExpiryDate_Long < CurrentDate) {
      this.DriverLic_ExpiryDate_Long = null;
      this.Lng == "en" ? Swal("License Expiry Date Must be Greater than Current Date") : Swal("License Expiry Date Must be Greater than Current Date");
    }

  }


  ValidateYear(val) {
    if (val < 1400 || val > 1522) {
      this.ErrorYear = true;
    } else {
      this.ErrorYear = false;
    }
  }

  ValidateSpecialChar(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  OfficeCityChange(val) {
    this.diverObj.OfficeZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }

  ResCityChange(val) {
    this.diverObj.ResidenceZone = this.bindObj.RegionMasterList.filter(t => t.CityCode == val)[0].RegionName;
  }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalDriverInfo/RenewalDriverInfo.ts